import {
  GET_REGULATORY_BODIES,
  GET_REGULATORY_BODIES_COMPLETED,
  GET_REGULATORY_BODIES_FAILED,
  GET_REGULATORY_BODY,
  GET_REGULATORY_BODY_COMPLETED,
  GET_REGULATORY_BODY_FAILED,
  ADD_REGULATORY_BODY,
  ADD_REGULATORY_BODY_COMPLETED,
  ADD_REGULATORY_BODY_FAILED,
  UPDATE_REGULATORY_BODY,
  UPDATE_REGULATORY_BODY_COMPLETED,
  UPDATE_REGULATORY_BODY_FAILED,
  DELETE_REGULATORY_BODY,
  DELETE_REGULATORY_BODY_COMPLETED,
  DELETE_REGULATORY_BODY_FAILED,
  SHOW_DELETE_REGULATORY_BODY_MODAL,
  HIDE_DELETE_REGULATORY_BODY_MODAL,
  SEARCH_REGULATORY_BODIES,
  SEARCH_REGULATORY_BODIES_COMPLETED,
  SEARCH_REGULATORY_BODIES_FAILED,
} from "./actions";
import {AUTH_LOGOUT} from "../Auth/actions";
import {handleSearch, handleSearchCompleted, handleSearchFailed, searchDefault} from "../utils/search";

const defaultState = {
  regulatoryBodies: [],
  regulatoryBodiesLoading: false,
  regulatoryBodiesError: null,
  regulatoryBody: null,
  regulatoryBodyLoading: false,
  regulatoryBodyError: null,
  addingRegulatoryBody: false,
  search: searchDefault,
  updatingRegulatoryBody: false,
  deleteRegulatoryBodyModalVisible: false,
  regulatoryBodyDeleting: false,
};

const regulatoryBodyReducer = (
  state = defaultState,
  action
) => {
  switch (action.type) {
    case SEARCH_REGULATORY_BODIES:
      return handleSearch(state, 'search', action.payload);
    case SEARCH_REGULATORY_BODIES_COMPLETED:
      return handleSearchCompleted(state, 'search', action.payload);
    case SEARCH_REGULATORY_BODIES_FAILED:
      return handleSearchFailed(state, 'search', action.payload);
    case GET_REGULATORY_BODIES: {
      return {
        ...state,
        regulatoryBodiesLoading: true,
        regulatoryBodies: [],
        regulatoryBodiesError: null,
      };
    }
    case GET_REGULATORY_BODIES_COMPLETED: {
      return {
        ...state,
        regulatoryBodiesLoading: false,
        regulatoryBodies: action.payload.data,
      };
    }
    case GET_REGULATORY_BODIES_FAILED: {
      return {
        ...state,
        regulatoryBodiesLoading: false,
        regulatoryBodiesError: action.payload,
      };
    }
    case GET_REGULATORY_BODY: {
      return {
        ...state,
        regulatoryBodyLoading: true,
        regulatoryBody: null,
        regulatoryBodyError: null,
      };
    }
    case GET_REGULATORY_BODY_COMPLETED: {
      return {
        ...state,
        regulatoryBodyLoading: false,
        regulatoryBody: action.payload,
      };
    }
    case GET_REGULATORY_BODY_FAILED: {
      return {
        ...state,
        regulatoryBodyLoading: false,
        regulatoryBodyError: action.payload,
      };
    }
    case ADD_REGULATORY_BODY: {
      return {
        ...state,
        addingRegulatoryBody: true,
      };
    }
    case ADD_REGULATORY_BODY_COMPLETED: {
      return {
        ...state,
        addingRegulatoryBody: false,
      };
    }
    case ADD_REGULATORY_BODY_FAILED: {
      return {
        ...state,
        addingRegulatoryBody: false,
      };
    }
    case UPDATE_REGULATORY_BODY: {
      return {
        ...state,
        updatingRegulatoryBody: true,
      };
    }
    case UPDATE_REGULATORY_BODY_COMPLETED: {
      return {
        ...state,
        updatingRegulatoryBody: false,
      };
    }
    case UPDATE_REGULATORY_BODY_FAILED: {
      return {
        ...state,
        updatingRegulatoryBody: false,
      };
    }
    case SHOW_DELETE_REGULATORY_BODY_MODAL: {
      return {
        ...state,
        deleteRegulatoryBodyModalVisible: true,
        regulatoryBodyToDelete: action.payload,
      };
    }
    case HIDE_DELETE_REGULATORY_BODY_MODAL: {
      return {
        ...state,
        deleteRegulatoryBodyModalVisible: false,
        regulatoryBodyToDelete: null,
      };
    }
    case DELETE_REGULATORY_BODY: {
      return {
        ...state,
        regulatoryBodyDeleting: true,
      };
    }
    case DELETE_REGULATORY_BODY_COMPLETED: {
      return {
        ...state,
        regulatoryBodyDeleting: false,
      };
    }
    case DELETE_REGULATORY_BODY_FAILED: {
      return {
        ...state,
        regulatoryBodyDeleting: false,
      };
    }
    case AUTH_LOGOUT: {
      return defaultState;
    }
    default:
      return state;
  }
};

export default regulatoryBodyReducer;



// WEBPACK FOOTER //
// ./src/RegulatoryBody/reducer.js